import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=87ce727c&scoped=true"
import script from "./Contracts.vue?vue&type=script&lang=js"
export * from "./Contracts.vue?vue&type=script&lang=js"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=87ce727c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ce727c",
  null
  
)

export default component.exports